<template>
  <main class="wrapper-content w-100">
    <!-- Loading -->
    <LmComponentLoading v-if="isLoading" fixed />

    <portal to="name">
      <!-- Input del nombre -->
      <LmTextInput
        class="col-12 px-0"
        v-model="$v.form.name.$model"
        :v="validation('form.name')"
        :label="$t('name')"
        :placeholder="$t('name')"
      />
    </portal>

    <portal to="parents" v-if="isChild && pathToGetOptionsForParents">
      <!-- TreeSelect con los padres -->
      <LmTreeSelect
        :label="parentCodificatorBuilder.name || 'Codificadores padre'"
        :pathToGetOptions="pathToGetOptionsForParents"
        :multiple="true"
        v-model="form.parentCodificatorId"
      />
    </portal>

    <portal to="children" v-if="!isChild && pathToGetOptionsForChildren">
      <!-- TreeSelect con los hijos -->
      <LmTreeSelect
        :label="childrenCodificatorBuilder.name || 'Codificadores hijo'"
        :pathToGetOptions="pathToGetOptionsForChildren"
        :multiple="true"
        v-model="form.childrenCodificators"
      />
    </portal>

    <!-- Formbuilder Server Components -->
    <LmFormBuilder
      class="col-12 px-0"
      v-if="formbuilderId"
      ref="lmFormbuilder"
      :endpointUriwhereGetComponents="formbuilderPath"
      :endpointUriWhereGetValuesToLoadInEditMode="pathToGetDataOnEditMode"
      @formObjectToSendToServerChange="updateForm($event)"
    />

    <!-- Action Buttons -->
    <div class="row">
      <LmButton
        :value="$t('cancel')"
        class="col-auto"
        type="button"
        buttonClass="btn-secondary"
        @click="onCancel()"
      />
      <LmButton
        v-if="!isDeleted"
        :value="$t('save')"
        class="col-auto"
        type="button"
        buttonClass="btn-primary"
        @click="onSubmit()"
      />
      <LmButton
        v-if="isOnEditMode && !isDeleted"
        :value="$t('defuse')"
        class="col-auto"
        type="button"
        action="delete"
        buttonClass="btn-danger"
        @click="onDelete()"
      />
      <LmButton
        v-if="isOnEditMode && isDeleted"
        :value="$t('activate')"
        class="col-auto"
        type="button"
        buttonClass="btn-primary"
        @click="onActivate()"
      />
    </div>
  </main>
</template>

<script>
// Components
import LmButton from '@/components/form/elements/LmButton'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmFormBuilder from '@/components/LmFormBuilder'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'

// Utils
import commonsApi from '@/api/commons'
import lmToasts from '@/mixins/lmToasts.js'
import _ from 'lodash'
import {
  required
} from 'vuelidate/lib/validators'

export default {
  mixins: [lmToasts],
  components: {
    LmFormBuilder,
    LmButton,
    LmTextInput,
    LmTreeSelect
  },
  props: {
    isOnEditMode: {
      type: Boolean,
      default: false
    },
    isCustomer: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      formbuilderId: '',
      listbuilderId: '',
      codificatorBuilderId: '',
      parentCodificatorBuilder: {},
      childrenCodificatorBuilder: {},
      isChild: false,
      isDeleted: false,
      form: {
        name: '',
        parentCodificatorId: [],
        childrenCodificators: []
      },
      isLoading: false
    }
  },
  validations: {
    form: {
      name: {
        required
      }
    }
  },
  computed: {
    requestsPrefixPath () {
      return this.isCustomer ? '/customercodificator/' : '/codificator/'
    },
    formbuilderPath () {
      return `/formbuilder/${this.formbuilderId}`
    },
    pathToGetDataOnEditMode () {
      if (this.isOnEditMode) {
        return `${this.requestsPrefixPath}${this.$route?.params?.id}`
      } else {
        return ''
      }
    },
    pathToGetOptionsForParents () {
      if (this.parentCodificatorBuilder?.id) {
        return `/codificatorbuilder/codificators/${this.parentCodificatorBuilder?.id}`
      }
      return null
    },
    pathToGetOptionsForChildren () {
      if (this.childrenCodificatorBuilder?.id) {
        return `/codificatorbuilder/codificators/${this.childrenCodificatorBuilder?.id}`
      }
      return null
    }
  },
  methods: {
    validation (position) {
      return _.get(_.cloneDeep(this.$v), position)
    },
    async onSubmit () {
      try {
        this.isLoading = true
        // Validaciones
        await this.validateForm(this.$v)
        await this.validateForm(this.$refs.lmFormbuilder.$v)

        const dataToSendToServer = {
          codificatorBuilderId: this.codificatorBuilderId,
          ...this.form
        }
        if (!this.isOnEditMode) {
          // nuevo
          const res = await commonsApi.axiosPostWrapper(this.requestsPrefixPath, dataToSendToServer)
          this.lmToastSuccessMessage(`Se creó ${res?.data?.name || ' el codificador'} correctamente.`, 'Se guardó exitosamente')
        } else {
          // editar
          const res = await commonsApi.axiosPutWrapper(`${this.requestsPrefixPath}${this.$route?.params?.id}`, dataToSendToServer)
          this.lmToastSuccessMessage(`Se editó ${res?.data?.name || ' el codificador'} correctamente.`, 'Se guardó exitosamente')
        }

        setTimeout(() => {
          this.$router.push(`/listbuilder/view/${this.listbuilderId}`)
        }, 650)
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    async onDelete () {
      try {
        this.isLoading = true
        const res = await commonsApi.axiosPutWrapper(`${this.requestsPrefixPath}delete/${this.$route?.params?.id}`)
        this.lmToastSuccessMessage(`Se desactivó ${res?.data?.name || ' el codificador'} correctamente.`, 'Se desactivó exitosamente')
        setTimeout(() => {
          this.$router.push(`/listbuilder/view/${this.listbuilderId}`)
        }, 650)
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    async onActivate () {
      try {
        this.isLoading = true
        const res = await commonsApi.axiosPutWrapper(`${this.requestsPrefixPath}activate/${this.$route?.params?.id}`)
        this.lmToastSuccessMessage(`Se activó ${res?.data?.name || ' el codificador'} correctamente.`, 'Se activó exitosamente')
        setTimeout(() => {
          this.$router.push(`/listbuilder/view/${this.listbuilderId}`)
        }, 650)
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    onCancel () {
      this.$router.push(`/listbuilder/view/${this.listbuilderId}`)
    },
    updateForm (event) {
      this.form = Object.assign({}, this.form, event)
    },
    validateForm (validation) {
      validation.$touch()
      if (validation.$error) {
        this.lmToastDangerMessage(this.$t('form_with_errors'), 'Error')
        throw new Error('validation error')
      } else {
        if (validation.$pending || validation.$error) {
          throw new Error('validation error')
        }
      }
    },
    async loadContentOnEditMode () {
      if (this.isOnEditMode) {
        try {
          this.isLoading = true
          const codificator = await commonsApi.axiosGetWrapper(this.pathToGetDataOnEditMode)

          // Guardo solo los campos necesarios
          for (const key in this.form) {
            this.form[key] = codificator.data[key]
          }
          this.isDeleted = codificator.data.deleted
          // this.form = codificator.data
        } catch (error) {
          console.log(error)
        } finally {
          this.isLoading = false
        }
      }
    }
  },
  async created () {
    try {
      // Guardo los datos importantes del codificador builder
      const codificatorBuilder = await commonsApi.axiosGetWrapper(`/${this.isCustomer ? 'customer' : ''}codificatorbuilder/${this.$route?.params?.builderId}`)
      this.formbuilderId = codificatorBuilder.data?.formbuilderId
      this.listbuilderId = codificatorBuilder.data?.listbuilderId
      this.codificatorBuilderId = codificatorBuilder.data?._id
      this.parentCodificatorBuilder = codificatorBuilder.data?.parentCodificatorBuilder || {}
      this.childrenCodificatorBuilder = codificatorBuilder.data?.childrenCodificatorBuilder || {}
      this.isChild = codificatorBuilder.data?.isChild
      await this.loadContentOnEditMode()
    } catch (error) {
      console.log(error)
    }
  }
}
</script>
